import React from 'react';

import styles from '~/components/lawns/digital-soil-test/digital-soil-test.module.scss';

const MARKER_THEMES = {
  low: {
    border: '0.5px solid #F5D242',
    backgroundColor: 'rgba(245, 210, 66, 0.3)',
  },
  medium: {
    backgroundColor: 'rgba(173, 193, 120, 0.3)',
    border: '0.5px solid #ADC178',
  },
  high: {
    backgroundColor: 'rgba(173, 193, 120, 0.3)',
    border: '0.5px solid #ADC178',
  },
};

export const ThreeColorGraph = ({ value }) => {
  let markerPosition = '16.6%';

  if (value === 'medium') {
    markerPosition = '50%';
  } else if (value === 'high') {
    markerPosition = '83.3%';
  }
  return (
    <div className={styles.graph}>
      <div className={styles.tick} style={{ left: '0' }} />
      <div className={styles.tick} style={{ left: '33.3%' }} />
      <div className={styles.tick} style={{ left: '66.7%' }} />
      <div className={styles.tick} style={{ right: '0' }} />
      <div className={styles.barContainer}>
        <div
          className={styles.bar}
          style={{ backgroundColor: 'rgba(173, 193, 120, 0.6)' }}
        >
          <div className={styles.barLabel}>low</div>
        </div>
        <div className={styles.bar} style={{ backgroundColor: '#ADC178' }}>
          <div className={styles.barLabel}>med</div>
        </div>
        <div className={styles.bar} style={{ backgroundColor: '#5D761A' }}>
          <div className={styles.barLabel}>high</div>
        </div>
      </div>
      <div className={styles.marker} style={{ left: markerPosition }} />
      <div
        className={styles.markerLabel}
        style={{ left: markerPosition, ...MARKER_THEMES[value] }}
      >
        {value}
      </div>
    </div>
  );
};

export const TwoColorGraph = ({ value }) => {
  let markerPosition = '25%';

  if (value === 'high') {
    markerPosition = '75%';
  }
  return (
    <div className={styles.graph}>
      <div className={styles.tick} style={{ left: '0' }} />
      <div className={styles.tick} style={{ left: '50%' }} />
      <div className={styles.tick} style={{ right: '0' }} />
      <div className={styles.barContainer}>
        <div className={styles.bar} style={{ backgroundColor: '#F5D242' }}>
          <div className={styles.barLabel}>low</div>
        </div>
        <div className={styles.bar} style={{ backgroundColor: '#ADC178' }}>
          <div className={styles.barLabel}>high</div>
        </div>
      </div>
      <div className={styles.marker} style={{ left: markerPosition }} />
      <div
        className={styles.markerLabel}
        style={{ left: markerPosition, ...MARKER_THEMES[value] }}
      >
        {value}
      </div>
    </div>
  );
};
